
import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faGlobe } from '@fortawesome/pro-light-svg-icons';
import { LocaleConfig, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { IconModule } from '@ogs-gmbh/ngx-m3-components';
import { LanguageSelectionService } from '../../services/language-selection/language-selection.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-language-select',
  standalone: true,
  imports: [ MatSelectModule, MatFormFieldModule, IconModule, TranslationPipeModule ],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectComponent {
  protected _languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);

  protected currentLocale: Signal<LocaleConfig | undefined> = toSignal(this._languageSelectionService.currentLocale$);

  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  constructor () {
    this._faIconLibrary.addIcons(faGlobe);
  }

  protected onLocaleSelectionChange (selectChangeEvent: MatSelectChange): void {
    this._languageSelectionService.setLocale(selectChangeEvent.value as LocaleConfig);
  }
}
